import { useState, useEffect, useRef } from "react";
import { Button, ButtonGroup, Row, Col, Modal
// ToggleButtonGroup,
// ToggleButton,
} from "react-bootstrap";
import { IntlProvider, FormattedMessage } from "react-intl";
import enMessages from "./locales/en.json";
import arMessages from "./locales/ar.json";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
// import CenterDropdown from "./components/CenterDropdown";
import StudentDetailsStep from "./components/steps/StudentDetailsStep";
import RequiredDocumentsStep from "./components/steps/RequiredDocumentsStep";
import MediaConsentStep from "./components/steps/MediaConsentStep";
import ClinicInformationStep from "./components/steps/ClinicInformationStep";
import AllergiesStep from "./components/steps/AllergiesStep";
import QuestionAnswerStep from "./components/steps/QuestionAnswerStep";
import TermsConditionsStep from "./components/steps/TermsConditionsStep";
var Chance = require("chance");
var chance = new Chance();
const App = () => {
  // Get query parameters
  const queryParameters = new URLSearchParams(window.location.search);
  const aid = queryParameters.get("aid");

  // Refs
  const recaptcha = useRef();

  // Constants
  const center_uuid = {
    511: "03f2086f-9f7b-4470-9f09-3202c6b0e724"
  };
  const version = "2.1";
  const API_URL = process.env.REACT_APP_API_URL;
  const PORTAL_URL = process.env.REACT_APP_PORTAL_URL;
  const messages = {
    en: enMessages,
    ar: arMessages
  };
  const steps = [{
    name: "step.student_details",
    step: 1
  }, {
    name: "step.required_documents",
    step: 2
  },
  // { name: "step.individual_profile_plan", step: 3 },
  {
    name: "step.visual_media_consent",
    step: 3
  }, {
    name: "step.clinic_information",
    step: 4
  }, {
    name: "step.known_allergies",
    step: 5
  }, {
    name: "step.question_answer",
    step: 6
  }, {
    name: "step.terms_conditions",
    step: 7
  }];
  const allergyOptions = ["Cow’s Milk", "Eggs", "Peanuts", "Tree Nuts (Almonds, Walnuts)", "Wheat", "Soy", "Fish", "Sesame", "Pollen", "Dust Mites", "Pet Allergy", "Insect Stings", "Medications", "Latex", "Any Contact Allergens", "No Known Allergies"];
  const chronicIllnesses = ["Vision Impairment", "Epilepsy", "Diabetes Type 1", "Diabetes Type 2", "Gastric Disorders", "Hearing Difficulties", "Heart Disease", "Blood Disorders", "Kidney Disease", "Liver Disease", "Autoimmune Disease", "Asthma", "High Blood Pressure", "N/A"];
  const errorsObj = {
    // center_id: false,
    captcha: false,
    child_name: false,
    child_family_name: false,
    birth_date: false,
    gender: false,
    religion: false,
    country_id: false,
    id_number: false,
    agegroup_id: false,
    spouse_role: false,
    father_name: false,
    father_mobile: false,
    father_email: false,
    father_nationality: false,
    mother_name: false,
    mother_mobile: false,
    mother_email: false,
    mother_nationality: false,
    emergency_contact1: false,
    emergency_relation1: false,
    emergency_phone1: false,
    bloodgroup: false
  };

  // State
  const [signature, setSignature] = useState(null);
  const [locale, setLocale] = useState("en");
  const [countries, setCountries] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [ageGroup, setAgeGroup] = useState([]);
  const [admissionAttachments, setAdmissionAttachments] = useState([]);
  const [errors, setErrors] = useState(errorsObj);
  const [step, setStep] = useState(1);
  const [stepName, setStepName] = useState("step.student_details");
  const [formSaving, setFormSaving] = useState(false);
  const [formData, setFormData] = useState({
    admission_id: 0,
    center_id: 511,
    // center_uuid: "",
    child_name: "",
    child_middle_name: "",
    child_family_name: "",
    birth_date: "",
    gender: "",
    country_id: "",
    religion: "",
    id_number: "",
    agegroup_id: "",
    sponsor_role: "Father",
    father_name: "",
    father_mobile: "",
    father_workphone: "",
    father_email: "",
    father_employer: "",
    father_position: "",
    father_nationality: "",
    home_address: "",
    spouse_role: "Mother",
    mother_name: "",
    mother_mobile: "",
    mother_workphone: "",
    mother_email: "",
    mother_employer: "",
    mother_position: "",
    mother_nationality: "",
    child_siblings: "",
    child_siblings_age: "",
    child_school_attending: "",
    emergency_contact1: "",
    emergency_relation1: "",
    emergency_phone1: "",
    admissioncountries: [],
    child_position_family: "1st Child",
    first_lang: "",
    second_lang: "",
    child_religion_food_clothing_desc: "",
    child_prev_settings: "",
    child_diet_milktype: "",
    child_diet_milktype_qty: "1",
    child_diet_milktype_freq: "1",
    child_weaningfood: "",
    child_weaningfood_volume: "1",
    child_weaningfood_freq: "1",
    child_weaningfood_snack: "",
    child_weaningfood_maincourse: "",
    child_weaningfood_puddings: "",
    child_sleep_time: "",
    child_sleep_mins: 1,
    child_sleep_comforters: "",
    child_use_toilet: [],
    child_use_drinkcup: "0",
    child_relate_children: 0,
    child_relate_familiar_adults: 0,
    child_take_turns: 0,
    notes: "",
    child_toys: "",
    child_activities: "",
    child_distress: "",
    child_extra_info: "",
    pic_nursery: 0,
    pic_media: 0,
    pic_social: 0,
    take_pictures: 1,
    bloodgroup: "",
    medical_emergency_name: "",
    medical_emergency_doc: "",
    medical_emergency_clinic: "",
    medical_emergency_phone: "",
    leela_allergies: "No",
    leela_dietry_intolerances: "No",
    leela_special_req: "No",
    allergies: "",
    allergic_reactions: "",
    attending_days: [],
    attending_times: [],
    qaAnswers: {},
    check_acknowledgement: 0,
    signature: ""
  });
  // const [otherAllergiesButtonValue, setOtherAllergiesButtonValue] = useState({
  //   leela_allergies_button: "No",
  //   leela_dietry_intolerances_button: "No",
  //   leela_special_req_button: "No",
  // });
  const [admission_question_answer, setAdmissionQuestionAnswer] = useState([]);
  const [health_declarations, setHealthDeclarations] = useState([]);
  const [picture, setPicture] = useState(null);
  const [child_eid_page, setChildEidPage] = useState(null);
  const [child_eid_page_back, setChildEidPageBack] = useState(null);
  const [child_passport, setChildPassport] = useState(null);
  const [visa_page, setVisaPage] = useState(null);
  const [birth_certcopy, setBirthCertcopy] = useState(null);
  const [vaccination_copy, setVaccinationCopy] = useState(null);
  const [prev_school_rep_doc, setPrevSchoolRepCopy] = useState(null);
  const [med_formcopy, setMedFormcopy] = useState(null);
  const [document1, setDocument1] = useState(null);
  const [father_id_attachment, setFatherIdAttachment] = useState(null);
  const [father_id_attachment_back, setFatherIdAttachmentBack] = useState(null);
  const [father_passport_attachment, setFatherPassportAttachment] = useState(null);
  // const [father_visa_attachment, setFatherVisaAttachment] = useState(null);
  const [mother_id_attachment, setMotherIdAttachment] = useState(null);
  const [mother_id_attachment_back, setMotherIdAttachmentBack] = useState(null);
  const [mother_passport_attachment, setMotherPassportAttachment] = useState(null);
  // const [mother_visa_attachment, setMotherVisaAttachment] = useState(null);

  const [chronicIllness, setChronicIllness] = useState("");
  const [chronicIllnessDesc, setChronicIllnessDesc] = useState("");
  const [chronicIllnessDate, setChronicIllnessDate] = useState("");
  const [illness, setIllness] = useState("");
  const [illnessDesc, setIllnessDesc] = useState("");
  const [illnessDate, setIllnessDate] = useState("");
  const [condition, setCondition] = useState("");
  const [conditionDesc, setConditionDesc] = useState("");
  const [conditionDate, setConditionDate] = useState("");

  // const [acknowledgement, setAcknowledgement] = useState(false);

  const [admissionAttachmentModal, setAdmissionAttachmentModal] = useState({
    show: false,
    title: "",
    content: ""
  });

  // On component load
  useEffect(() => {
    getCountries();
    getActiveBoardAge();
    if (aid) {
      getAdmissionData();
    }
  }, []);

  // On step change
  useEffect(() => {
    if (step === 7) {
      getAdmissionAttachments();
    }
  }, [step]);
  useEffect(() => {
    const initialAnswers = {};
    if (questions?.length && admission_question_answer?.length) {
      admission_question_answer.forEach(ans => {
        const question = questions.flatMap(group => group.admission_questions || []).find(q => q.adm_quest_id === ans.adm_quest_id);
        if (question) {
          const isTrueFalse = question?.adm_tf === 1;
          initialAnswers[ans.adm_quest_id] = {
            value: isTrueFalse ? ans.adm_ans_answer?.toString() : ans.adm_ans_comment || "",
            comment: isTrueFalse ? ans.adm_ans_comment || "" : "",
            adm_ans_id: ans.adm_ans_id
          };
        }
      });
      setFormData(prevData => ({
        ...prevData,
        qaAnswers: initialAnswers
      }));
    }
  }, [questions, admission_question_answer]);

  // Get countries
  const getCountries = async () => {
    try {
      const response = await fetch(`${API_URL}/get-countries?tenant_id=f47ac10b58cc4372a5670e029j198745`, {
        method: "GET"
      });
      if (response.ok) {
        const data = await response.json();
        setCountries(data);
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };
  const getActiveBoardAge = async () => {
    try {
      const response = await fetch(`${API_URL}/get-active-board-age-groups?center_id=511&tenant_id=f47ac10b58cc4372a5670e029j198745`, {
        method: "GET"
      });
      if (response.ok) {
        const data = await response.json();
        setAgeGroup(data);
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  // Get Admission Attachments
  const getAdmissionAttachments = async () => {
    try {
      const response = await fetch(`${API_URL}/get-admission-attachments?center_id=${formData.center_id}&tenant_id=f47ac10b58cc4372a5670e029j198745`, {
        method: "GET"
      });
      if (response.ok) {
        const data = await response.json();
        console.log("data", data);
        setAdmissionAttachments(data);
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  // Get admission data
  const getAdmissionData = async () => {
    try {
      const response = await fetch(`${API_URL}/get-admission-data?admission_uuid=${aid}&tenant_id=f47ac10b58cc4372a5670e029j198745`, {
        method: "GET"
      });
      if (response.ok) {
        const data = await response.json();
        const {
          admission,
          admission_extra_info,
          children_health,
          admissioncountries,
          // admissionsiblings,
          admision_quest_answer
        } = data;
        setAdmissionQuestionAnswer(admision_quest_answer);
        setFormData(prevData => ({
          ...prevData,
          center_id: admission.center_id,
          admission_id: admission.admission_id,
          child_name: admission.child_name,
          child_middle_name: admission.child_middle_name,
          child_family_name: admission_extra_info.child_family_name,
          birth_date: admission.birth_date,
          gender: admission.gender,
          country_id: admission.country_id,
          religion: admission_extra_info.religion,
          id_number: admission.id_number,
          agegroup_id: admission.agegroup_id,
          sponsor_role: admission_extra_info.sponsor_role ?? "Father",
          father_name: admission.father_name,
          father_mobile: admission.father_mobile,
          father_workphone: admission.father_workphone,
          father_email: admission.father_email,
          father_employer: admission.father_employer,
          father_position: admission.father_position,
          father_nationality: admission.father_nationality,
          home_address: admission.home_address,
          spouse_role: admission_extra_info.spouse_role ?? "Mother",
          mother_name: admission.mother_name,
          mother_mobile: admission.mother_mobile,
          mother_workphone: admission.mother_workphone,
          mother_email: admission.mother_email,
          mother_employer: admission.mother_employer,
          mother_position: admission.mother_position,
          mother_nationality: admission.mother_nationality,
          child_siblings: admission_extra_info.child_siblings,
          child_siblings_age: admission_extra_info.child_siblings_age,
          child_school_attending: admission_extra_info.child_school_attending,
          emergency_contact1: admission.emergency_contact1,
          emergency_relation1: admission.emergency_relation1,
          emergency_phone1: admission.emergency_phone1,
          admissioncountries: admissioncountries?.length ? admissioncountries : [],
          child_position_family: admission_extra_info.child_position_family ?? "1st Child",
          first_lang: admission.first_lang,
          second_lang: admission.second_lang,
          child_religion_food_clothing_desc: admission_extra_info.child_religion_food_clothing_desc,
          child_prev_settings: admission_extra_info.child_prev_settings,
          child_diet_milktype: admission_extra_info.child_diet_milktype,
          child_diet_milktype_qty: admission_extra_info.child_diet_milktype_qty,
          child_diet_milktype_freq: admission_extra_info.child_diet_milktype_freq,
          child_weaningfood: admission_extra_info.child_weaningfood,
          child_weaningfood_volume: admission_extra_info.child_weaningfood_volume,
          child_weaningfood_freq: admission_extra_info.child_weaningfood_freq,
          child_weaningfood_snack: admission_extra_info.child_weaningfood_snack,
          child_weaningfood_maincourse: admission_extra_info.child_weaningfood_maincourse,
          child_weaningfood_puddings: admission_extra_info.child_weaningfood_puddings,
          child_sleep_time: admission_extra_info.child_sleep_time,
          child_sleep_mins: admission_extra_info.child_sleep_mins,
          child_sleep_comforters: admission_extra_info.child_sleep_comforters,
          child_use_toilet: admission_extra_info.child_use_toilet ? JSON.parse(admission_extra_info.child_use_toilet) : [],
          child_use_drinkcup: admission_extra_info.child_use_drinkcup,
          child_relate_children: admission_extra_info.child_relate_children,
          child_relate_familiar_adults: admission_extra_info.child_relate_familiar_adults,
          child_take_turns: admission_extra_info.child_take_turns,
          notes: admission.notes,
          child_toys: admission_extra_info.child_toys,
          child_activities: admission_extra_info.child_activities,
          child_distress: admission_extra_info.child_distress,
          child_extra_info: admission_extra_info.child_extra_info,
          pic_nursery: admission_extra_info.pic_nursery,
          pic_media: admission_extra_info.pic_media,
          pic_social: admission_extra_info.pic_social,
          take_pictures: admission_extra_info.take_pictures,
          bloodgroup: admission.bloodgroup,
          medical_emergency_name: admission_extra_info.medical_emergency_name,
          medical_emergency_doc: admission_extra_info.medical_emergency_doc,
          medical_emergency_clinic: admission_extra_info.medical_emergency_clinic,
          medical_emergency_phone: admission_extra_info.medical_emergency_phone,
          leela_allergies: admission_extra_info.leela_allergies,
          leela_dietry_intolerances: admission_extra_info.leela_dietry_intolerances,
          leela_special_req: admission_extra_info.leela_special_req,
          allergies: admission.allergies,
          allergic_reactions: admission_extra_info.allergic_reactions,
          attending_days: admission_extra_info.attending_days ? JSON.parse(admission_extra_info.attending_days) : [],
          attending_times: admission_extra_info.attending_times ? JSON.parse(admission_extra_info.attending_times) : [],
          check_acknowledgement: admission.check_acknowledgement || 0,
          signature: admission_extra_info.signature || null
        }));

        // setOtherAllergiesButtonValue((prevState) => ({
        //   ...prevState,
        //   leela_allergies_button:
        //     admission_extra_info.leela_allergies === "No" ? "No" : "Yes",
        //   leela_dietry_intolerances_button:
        //     admission_extra_info.leela_dietry_intolerances === "No"
        //       ? "No"
        //       : "Yes",
        //   leela_special_req_button:
        //     admission_extra_info.leela_special_req === "No" ? "No" : "Yes",
        // }));

        // Health Declarations
        if (children_health.length > 0) {
          const healthDeclarations = [];
          children_health.forEach(item => {
            healthDeclarations.push({
              ...item,
              uuid: chance.guid()
            });
          });
          setHealthDeclarations(healthDeclarations);
        }
        if (admission.picture) {
          setPicture({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission.picture}`
          });
        }
        if (admission.child_eid_page) {
          setChildEidPage({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission.child_eid_page}`
          });
        }
        if (admission_extra_info.child_eid_page_back) {
          setChildEidPageBack({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission_extra_info.child_eid_page_back}`
          });
        }
        if (admission.child_passport) {
          setChildPassport({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission.child_passport}`
          });
        }
        if (admission.visa_page) {
          setVisaPage({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission.visa_page}`
          });
        }
        if (admission.birth_certcopy) {
          setBirthCertcopy({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission.birth_certcopy}`
          });
        }
        if (admission.vaccination_copy) {
          setVaccinationCopy({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission.vaccination_copy}`
          });
        }
        if (admission.med_formcopy) {
          setMedFormcopy({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission.med_formcopy}`
          });
        }
        if (admission.prev_school_rep_doc) {
          setPrevSchoolRepCopy({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission.prev_school_rep_doc}`
          });
        }
        if (admission.document1) {
          setDocument1({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission.document1}`
          });
        }
        if (admission_extra_info.father_id_attachment) {
          setFatherIdAttachment({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission_extra_info.father_id_attachment}`
          });
        }
        if (admission_extra_info.father_id_attachment_back) {
          setFatherIdAttachmentBack({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission_extra_info.father_id_attachment_back}`
          });
        }
        if (admission_extra_info.father_passport_attachment) {
          setFatherPassportAttachment({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission_extra_info.father_passport_attachment}`
          });
        }

        // if (admission_extra_info.father_visa_attachment) {
        //   setFatherVisaAttachment({
        //     preview: `${
        //       PORTAL_URL + center_uuid[admission.center_id]
        //     }/admissions_school/${admission_extra_info.father_visa_attachment}`,
        //   });
        // }

        if (admission_extra_info.mother_id_attachment) {
          setMotherIdAttachment({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission_extra_info.mother_id_attachment}`
          });
        }
        if (admission_extra_info.mother_id_attachment_back) {
          setMotherIdAttachmentBack({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission_extra_info.mother_id_attachment_back}`
          });
        }
        if (admission_extra_info.mother_passport_attachment) {
          setMotherPassportAttachment({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission_extra_info.mother_passport_attachment}`
          });
        }
        if (admission_extra_info.signature) {
          setSignature({
            preview: `${PORTAL_URL + center_uuid[admission.center_id]}/admissions_school/${admission_extra_info.signature}`
          });
        }

        // if (admission_extra_info.mother_visa_attachment) {
        //   setMotherVisaAttachment({
        //     preview: `${
        //       PORTAL_URL + center_uuid.center_uuid
        //     }/admissions_school/${admission_extra_info.mother_visa_attachment}`,
        //   });
        // }
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  // Handle language change
  const handleLanguageChange = event => {
    setLocale(event.target.value);
  };

  // Handle input change
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    if (name === "child_use_toilet_0" || name === "child_use_toilet_1" || name === "child_use_toilet_2") {
      const index = name.split("_")[3];
      let child_use_toilet = formData.child_use_toilet;
      child_use_toilet[index] = value;
      setFormData(prevData => ({
        ...prevData,
        child_use_toilet
      }));
    } else {
      setFormData(prevData => ({
        ...prevData,
        [name]: value
      }));
    }
  };

  // Handle validation
  const validateStep = () => {
    let isValid = true;
    if (step === 1) {
      const captchaValue = recaptcha.current.getValue();
      if (!captchaValue) {
        errorsObj.captcha = true;
        isValid = false;
      }
      if (!picture) {
        errorsObj.picture = true;
        isValid = false;
      }
      if (!formData.child_name) {
        errorsObj.child_name = true;
        isValid = false;
      }
      if (!formData.child_family_name) {
        errorsObj.child_family_name = true;
        isValid = false;
      }
      if (!formData.birth_date) {
        errorsObj.birth_date = true;
        isValid = false;
      }
      if (!formData.gender) {
        errorsObj.gender = true;
        isValid = false;
      }
      if (!formData.religion) {
        errorsObj.religion = true;
        isValid = false;
      }
      if (!formData.country_id) {
        errorsObj.country_id = true;
        isValid = false;
      }
      if (!formData.id_number) {
        errorsObj.id_number = true;
        isValid = false;
      }
      if (!formData.agegroup_id) {
        errorsObj.agegroup_id = true;
        isValid = false;
      }
      if (!formData.father_name) {
        errorsObj.father_name = true;
        isValid = false;
      }
      if (!formData.father_mobile) {
        errorsObj.father_mobile = true;
        isValid = false;
      }
      if (!formData.father_email) {
        errorsObj.father_email = true;
        isValid = false;
      }
      if (!formData.father_nationality) {
        errorsObj.father_nationality = true;
        isValid = false;
      }
      if (!formData.mother_name) {
        errorsObj.mother_name = true;
        isValid = false;
      }
      if (!formData.mother_mobile) {
        errorsObj.mother_mobile = true;
        isValid = false;
      }
      if (!formData.mother_email) {
        errorsObj.mother_email = true;
        isValid = false;
      }
      if (!formData.mother_nationality) {
        errorsObj.mother_nationality = true;
        isValid = false;
      }
      if (!formData.emergency_contact1) {
        errorsObj.emergency_contact1 = true;
        isValid = false;
      }
      if (!formData.emergency_relation1) {
        errorsObj.emergency_relation1 = true;
        isValid = false;
      }
      if (!formData.emergency_phone1) {
        errorsObj.emergency_phone1 = true;
        isValid = false;
      }
    }
    if (step === 2) {
      if (!child_eid_page) {
        errorsObj.child_eid_page = true;
        isValid = false;
      }
      if (!child_eid_page_back) {
        errorsObj.child_eid_page_back = true;
        isValid = false;
      }
      if (!child_passport) {
        errorsObj.child_passport = true;
        isValid = false;
      }
      if (!birth_certcopy) {
        errorsObj.birth_certcopy = true;
        isValid = false;
      }
      if (!vaccination_copy) {
        errorsObj.vaccination_copy = true;
        isValid = false;
      }
      // if (!prev_school_rep_doc) {
      //   errorsObj.prev_school_rep_doc = true;
      //   isValid = false;
      // }
      if (!father_id_attachment) {
        errorsObj.father_id_attachment = true;
        isValid = false;
      }
      if (!father_id_attachment_back) {
        errorsObj.father_id_attachment_back = true;
        isValid = false;
      }
      if (!father_passport_attachment) {
        errorsObj.father_passport_attachment = true;
        isValid = false;
      }
      if (!mother_id_attachment) {
        errorsObj.mother_id_attachment = true;
        isValid = false;
      }
      if (!mother_id_attachment_back) {
        errorsObj.mother_id_attachment_back = true;
        isValid = false;
      }
      if (!mother_passport_attachment) {
        errorsObj.mother_passport_attachment = true;
        isValid = false;
      }
    }
    if (step === 4) {
      if (!formData.bloodgroup) {
        errorsObj.bloodgroup = true;
        isValid = false;
      }
      // if (health_declarations.length === 0) {
      //   errorsObj.chronicIllness = true;
      //   isValid = false;
      // }
      // if (!chronicIllness) {
      //   errorsObj.chronicIllness = true;
      //   isValid = false;
      // }
      // if (!chronicIllnessDesc) {
      //   errorsObj.chronicIllnessDesc = true;
      //   isValid = false;
      // }
      // if (!chronicIllnessDate) {
      //   errorsObj.chronicIllnessDate = true;
      //   isValid = false;
      // }
    }
    if (step === 5) {
      if (!formData.leela_allergies) {
        errorsObj.leela_allergies = true;
        isValid = false;
      }
    }
    if (step === 6) {
      questions?.forEach(group => {
        group.admission_questions.forEach(q => {
          const answerObj = formData.qaAnswers[q.adm_quest_id];
          const value = answerObj?.value;
          const isEmpty = value === undefined || value === null || value === "";
          if (q.adm_mandatory === 1 && isEmpty) {
            errorsObj[`qa_${q.adm_quest_id}`] = true;
            isValid = false;
          }
        });
      });
    }
    if (step === 7) {
      if (!signature) {
        errorsObj.signature = true;
        isValid = false;
      }
    }
    setErrors(errorsObj);
    return isValid;
  };

  // Handle Health Declaration Add
  const addHealthDeclaration = child_health_type => {
    const healthDeclaration = {
      child_health_name: "",
      child_health_desc: "",
      child_health_date: ""
    };
    if (child_health_type === "Chronic Illness") {
      if (!chronicIllness || !chronicIllnessDesc || !chronicIllnessDate) {
        toast.error(<FormattedMessage id="validation.fill_all_chronic_illness_fields" />);
        return;
      }
      healthDeclaration.child_health_name = chronicIllness;
      healthDeclaration.child_health_desc = chronicIllnessDesc;
      healthDeclaration.child_health_date = chronicIllnessDate;
    } else if (child_health_type === "Illness") {
      if (!illness || !illnessDesc || !illnessDate) {
        toast.error(<FormattedMessage id="validation.fill_all_illness_fields" />);
        return;
      }
      healthDeclaration.child_health_name = illness;
      healthDeclaration.child_health_desc = illnessDesc;
      healthDeclaration.child_health_date = illnessDate;
    } else if (child_health_type === "Condition") {
      if (!condition || !conditionDesc || !conditionDate) {
        toast.error(<FormattedMessage id="validation.fill_all_condition_fields" />);
        return;
      }
      healthDeclaration.child_health_name = condition;
      healthDeclaration.child_health_desc = conditionDesc;
      healthDeclaration.child_health_date = conditionDate;
    }
    setHealthDeclarations(prevHealthDeclarations => [...prevHealthDeclarations, {
      child_health_id: 0,
      uuid: chance.guid(),
      child_health_type,
      ...healthDeclaration
    }]);
    if (child_health_type === "Chronic Illness") {
      setChronicIllness("");
      setChronicIllnessDesc("");
      setChronicIllnessDate("");
    } else if (child_health_type === "Illness") {
      setIllness("");
      setIllnessDesc("");
      setIllnessDate("");
    } else if (child_health_type === "Condition") {
      setCondition("");
      setConditionDesc("");
      setConditionDate("");
    }
  };
  // Handle Health Declaration Remove
  const removeHealthDeclaration = uuid => {
    setHealthDeclarations(prevHealthDeclarations => prevHealthDeclarations.filter(healthDeclaration => healthDeclaration.uuid !== uuid));
  };

  // Handle next step
  const handleNextStep = () => {
    handleSubmit(null);
  };
  function getPostData() {
    const postData = [];
    questions.forEach(group => {
      group.admission_questions.forEach(q => {
        const answerObj = formData.qaAnswers[q.adm_quest_id];
        const isTrueFalse = q.adm_tf === 1;
        postData.push({
          adm_ans_id: answerObj?.adm_ans_id || 0,
          center_id: formData?.center_id,
          admission_id: formData?.admission_id,
          adm_quest_id: q.adm_quest_id,
          adm_ans_answer: isTrueFalse ? Number(answerObj?.value) === 1 ? 1 : Number(answerObj?.value) === 0 ? 0 : null : 0,
          adm_ans_comment: isTrueFalse ? answerObj?.comment || null : answerObj?.value || null
        });
      });
    });
    return postData;
  }

  // const handlePrevStep = () => {
  //   setStep(step - 1);
  // };

  //Handle button change
  // const handleButtonClick = (e) => {
  //   const { name, value } = e.target;

  //   // Update button value state
  //   setOtherAllergiesButtonValue((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));

  //   if (name === "leela_special_req_button") {
  //     setFormData((prevFormData) => ({
  //       ...prevFormData,
  //       leela_special_req: value === "No" ? "No" : "",
  //     }));
  //   } else if (name === "leela_dietry_intolerances_button") {
  //     setFormData((prevFormData) => ({
  //       ...prevFormData,
  //       leela_dietry_intolerances: value === "No" ? "No" : "",
  //     }));
  //   } else if (name === "leela_allergies_button") {
  //     setFormData((prevFormData) => ({
  //       ...prevFormData,
  //       leela_allergies: value === "No" ? "No" : "",
  //     }));
  //   }
  // };

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl?.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {
      type: mime
    });
  }
  const handleUpload = async file => {
    try {
      const fD = new FormData();
      fD.append("file", file);
      fD.append("field_name", "signature");
      fD.append("admission_id", formData.admission_id);
      const response = await fetch(`${API_URL}/upload-doc?tenant_id=f47ac10b58cc4372a5670e029j198745`, {
        method: "POST",
        body: fD
      });
      if (response.ok) {
        const data = await response.json();
        const {
          data: resData
        } = data;
        const signaturePath = resData["signature"];
        // console.log("Uploaded signature:", signaturePath);

        file.preview = `${PORTAL_URL + formData.center_uuid}/admissions_school/${signaturePath}`;
        setSignature(file);

        // 🔹 Update formData state
        setFormData(prev => ({
          ...prev,
          signature: signaturePath
        }));
        toast.success(<FormattedMessage id="validation.file_uploaded" />);
        return signaturePath;
      } else {
        console.log("NOT OK");
        return null;
      }
    } catch (error) {
      console.log("Error!", error);
      return null;
    }
  };
  const handleSubmit = async jumpStep => {
    let formDataObj = {
      ...formData
    };
    if (!validateStep()) {
      if (errorsObj.captcha) {
        toast.error(<FormattedMessage id="validation.captcha_required" />);
        return;
      } else {
        toast.warning(<FormattedMessage id="validation.fill_required_fields" />);
        return;
      }
    }
    setFormSaving(true);
    if (signature && !formDataObj.signature) {
      // Convert base64 to File (use dataURLtoFile from SignaturePad.js)
      const file = dataURLtoFile(signature, "signature.png");
      const uploadedSignature = await handleUpload(file);
      if (uploadedSignature) {
        formDataObj.signature = uploadedSignature;
      }
    }
    try {
      const fD = new FormData();
      formDataObj.child_use_toilet = JSON.stringify(formDataObj.child_use_toilet);
      if (step >= 7 && questions.length > 0) {
        const hasQAAnswers = Object.keys(formData.qaAnswers || {}).length > 0;
        if (hasQAAnswers) {
          const postData = getPostData();
          fD.append("answers", JSON.stringify(postData));
        }
      }
      fD.append("admissioncountries", JSON.stringify(formDataObj.admissioncountries));
      fD.append("formData", JSON.stringify(formDataObj));
      fD.append("picture", picture);
      fD.append("step", step);
      if (step === 1) {
        const captchaValue = recaptcha.current.getValue();
        fD.append("g-recaptcha-response", captchaValue);
      }
      health_declarations.length > 0 && health_declarations.forEach(healthDeclaration => {
        fD.append(`health_declarations[uuid][${healthDeclaration.uuid}]`, healthDeclaration.uuid);
        fD.append(`health_declarations[child_health_id][${healthDeclaration.uuid}]`, healthDeclaration.child_health_id);
        fD.append(`health_declarations[child_health_name][${healthDeclaration.uuid}]`, healthDeclaration.child_health_name);
        fD.append(`health_declarations[child_health_desc][${healthDeclaration.uuid}]`, healthDeclaration.child_health_desc);
        fD.append(`health_declarations[child_health_date][${healthDeclaration.uuid}]`, moment(healthDeclaration.child_health_date).format("YYYY-MM-DD"));
        fD.append(`health_declarations[child_health_type][${healthDeclaration.uuid}]`, healthDeclaration.child_health_type);
      });
      const response = await fetch(`${API_URL}/save-admission-data?tenant_id=f47ac10b58cc4372a5670e029j198745`, {
        method: "POST",
        body: fD
      });
      if (response.ok) {
        const {
          data,
          type,
          message
        } = await response.json();
        if (type) {
          const {
            admission,
            question_grps
          } = data;
          const {
            admission_id,
            admission_uuid
          } = admission;
          setQuestions(question_grps);
          setFormData(prevData => ({
            ...prevData,
            admission_id
          }));
          window.history.pushState({
            aid: admission_id
          }, "", `?aid=${admission_uuid}`);
          let stepNum = 0;
          if (step < steps.length && !jumpStep) {
            stepNum = step + 1;
            setStep(stepNum);
            setStepName(steps[stepNum - 1].name);
          } else if (jumpStep) {
            stepNum = jumpStep;
            setStep(stepNum);
            setStepName(steps[stepNum - 1].name);
          }
          toast.success(<FormattedMessage id="validation.saved_successfully" />);
        } else {
          if (message) {
            toast.info(message);
          }
          console.log("Error submitting form");
        }
      } else {
        console.log("Error submitting form");
      }
      setFormSaving(false);
    } catch (error) {
      setFormSaving(false);
      console.log("Something went wrong!");
      console.log(error);
    }
  };
  return <IntlProvider locale={locale} messages={messages[locale]}>
      <div id="page" dir={locale === "en" ? "ltr" : "rtl"}>
        <aside id="sidebar" className="d-none d-md-block position-relative">
          <small className="text-muted" style={{
          position: "absolute",
          bottom: 20,
          left: locale === "en" ? 20 : "auto",
          right: locale === "ar" ? 20 : "auto"
        }}>
            v{version}
          </small>
          <Row className="aside-header align-items-center">
            <Col className="brand-block">
              <img className="academy-logo" src={require("./assets/Smart international academy.jpeg")} alt="Smart International Academy" />
            </Col>
            <Col className="lang-switcher text-end">
              <ButtonGroup>
                <Button size="sm" onClick={handleLanguageChange} value="en" variant={locale === "en" ? "secondary" : "light"}>
                  EN
                </Button>
                <Button size="sm" onClick={handleLanguageChange} value="ar" variant={locale === "ar" ? "secondary" : "light"}>
                  AR
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <div className="steps-list">
            <ul>
              {steps.map((item, index) => <li key={index} className={step === index + 1 ? "active" : ""}>
                  <Button variant="link" onClick={() => {
                handleSubmit(index + 1);
              }}>
                    <span className="step-number">{index + 1}</span>
                    <FormattedMessage id={item.name} />
                  </Button>
                </li>)}
            </ul>
          </div>
        </aside>
        <div id="content">
          <Row className="res-header d-md-none align-items-center">
            <Col>
              <img className="academy-logo" src={require("./assets/Smart international academy.jpeg")} alt="Smart International Academy" />
            </Col>
            <Col className="lang-switcher text-end">
              <ButtonGroup>
                <Button size="sm" onClick={handleLanguageChange} value="en" variant={locale === "en" ? "secondary" : "light"}>
                  EN
                </Button>
                <Button size="sm" onClick={handleLanguageChange} value="ar" variant={locale === "ar" ? "secondary" : "light"}>
                  AR
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <div id="content_child" className="position-relative">
            <div className="form-nav">
              <Button variant={step === steps.length ? "success" : "primary"} onClick={handleNextStep} disabled={formSaving || (step === steps.length && (Number(formData?.check_acknowledgement) !== 1 || !signature))}>
                <FormattedMessage id={step === steps.length ? "submit" : "next"} />
              </Button>
            </div>
            <h2 className="mb-3">
              <FormattedMessage id={stepName} />
            </h2>

            {/* STEP 1 */}
            {step === 1 && <StudentDetailsStep ctx={{
            ageGroup,
            countries,
            errors,
            formData,
            handleChange,
            picture,
            recaptcha,
            setFormData,
            setPicture
          }} />}

            {/* STEP 2 */}
            {step === 2 && <RequiredDocumentsStep ctx={{
            birth_certcopy,
            center_uuid,
            child_eid_page,
            child_eid_page_back,
            child_passport,
            document1,
            errors,
            father_id_attachment,
            father_id_attachment_back,
            father_passport_attachment,
            formData,
            med_formcopy,
            mother_id_attachment,
            mother_id_attachment_back,
            mother_passport_attachment,
            prev_school_rep_doc,
            setBirthCertcopy,
            setChildEidPage,
            setChildEidPageBack,
            setChildPassport,
            setDocument1,
            setFatherIdAttachment,
            setFatherIdAttachmentBack,
            setFatherPassportAttachment,
            setMedFormcopy,
            setMotherIdAttachment,
            setMotherIdAttachmentBack,
            setMotherPassportAttachment,
            setPrevSchoolRepCopy,
            setVaccinationCopy,
            setVisaPage,
            vaccination_copy,
            visa_page
          }} />}

            {/* STEP 3 */}
            {step === 3 && <MediaConsentStep ctx={{
            formData,
            handleChange
          }} />}

            {/* STEP 4 */}
            {step === 4 && <ClinicInformationStep ctx={{
            addHealthDeclaration,
            chronicIllness,
            chronicIllnessDate,
            chronicIllnessDesc,
            chronicIllnesses,
            errors,
            formData,
            handleChange,
            health_declarations,
            removeHealthDeclaration,
            setChronicIllness,
            setChronicIllnessDate,
            setChronicIllnessDesc
          }} />}

            {/* STEP 5 */}
            {step === 5 && <AllergiesStep ctx={{
            allergyOptions,
            errors,
            formData,
            handleChange
          }} />}

            {/* STEP 6 */}
            {step === 6 && <QuestionAnswerStep ctx={{
            errors,
            formData,
            locale,
            questions,
            setFormData
          }} />}

            {/* STEP 7 */}
            {step === 7 && <TermsConditionsStep ctx={{
            admissionAttachments,
            errors,
            formData,
            setAdmissionAttachmentModal,
            setFormData,
            setSignature,
            signature
          }} />}
          </div>
        </div>
      </div>
      <Modal size="xl" show={admissionAttachmentModal.show} onHide={() => setAdmissionAttachmentModal({
      show: false,
      title: "",
      content: ""
    })}>
        <Modal.Header closeButton>
          <Modal.Title>{admissionAttachmentModal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{
          __html: admissionAttachmentModal.content
        }} />
        </Modal.Body>
      </Modal>
      <ToastContainer position={locale === "en" ? "bottom-right" : "bottom-left"} rtl={locale === "ar"} hideProgressBar={true} theme="colored" />
    </IntlProvider>;
};
export default App;
